
import React from 'react';
import { 
  Autocomplete, 
  TextField, 
  Box,
  Popover,
  IconButton,
  Typography,
  CircularProgress
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectPermissions } from '../../redux/permissionsSlice';
import SearchIcon from '@mui/icons-material/Search';
import MicIcon from '@mui/icons-material/Mic';
import MicOffIcon from '@mui/icons-material/MicOff';
import InputAdornment from '@mui/material/InputAdornment';

// Speech recognition import
let SpeechRecognition;
if (typeof window !== 'undefined') {
  SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
}

const SearchModule = () => {
  const navigate = useNavigate();
  const [searchValue, setSearchValue] = React.useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isListening, setIsListening] = React.useState(false);
  const [transcript, setTranscript] = React.useState('');
  const [recognition, setRecognition] = React.useState(null);
  const permissions = useSelector(selectPermissions);

  const moduleOptions = [
    { label: 'Dashboard', route: '/dashboard' },
    { label: 'Company Master', route: '/masters/companytable' },
    { label: 'User Master', route: '/userMasterTable' },
    { label: 'Employee Master', route: '/employeetable' },
    { label: 'Employee Type Master', route: '/employeetypetable' },
    { label: 'Designation Master', route: '/designationtable' },
    { label: 'Payment Plan Master', route: '/roomPlanTable' },
    { label: 'Promocode Master', route: '/promotable' },
    { label: 'Coupon Authority', route: '/couponAuthorityTable' },
    { label: 'Coupon Master', route: '/generate-coupon-table' },
    { label: 'Topup Master', route: '/Topup_Table' },
    { label: 'Transport Plan', route: '/transport-plan-table' },
    { label: 'Mess Plan', route: '/mess-plan-table' },
    // First Grid
    { label: 'Property Master', route: '/propertytable' },
    { label: 'Room Master', route: '/room-master-table' },
    { label: 'Bed Master', route: '/roomBednumbertable' },
    { label: 'Wing Master', route: '/wingtable' },
    { label: 'Floor Master', route: '/floortable' },
    { label: 'PropertyType Master', route: '/propertyTypetable' },
    { label: 'Room Type Master', route: '/roomTypetable' },
    { label: 'BedType Master', route: '/roomBedTypetable' },
    { label: 'Room View', route: '/roomViewtable' },
    { label: 'Facilities Master', route: '/facilitiesmastertable' },
    { label: 'Amenities Master', route: '/amenitytable' },
    { label: 'Common Area', route: '/commonareatable' },
    { label: 'Generate Calender', route: '/generatecalender' },

    // Second Grid
    { label: 'Resident Master', route: '/masters/residenttable' },
    { label: 'Vendors & Creditors', route: '/partytable' },
    { label: 'Corporate Master', route: '/corporateTable' },
    { label: 'Institute Master', route: '/instituteMasterTable' },
    { label: 'Course Master', route: '/coursetable' },
    { label: 'Semester Master', route: '/semestertable' },
    { label: 'Source Master', route: '/sourceMstTable' },
    { label: 'Bank Master', route: '/bank-table' },
    { label: 'Relation Master', route: '/relation-table' },
    { label: 'Class Master', route: '/classtable' },
    { label: 'Rating Master', route: '/ratingtable' },

    // Third Grid
    { label: 'Category Master', route: '/categorytable' },
    { label: 'Group Master', route: '/grptable' },
    { label: 'SubGroup Master', route: '/subgrptable' },
    { label: 'Assets/Store Master', route: '/assettable' },
    { label: 'Unit Master', route: '/unittable' },

    // Fourth Grid
    { label: 'Main Group', route: '/maingrptable' },
    { label: 'Groups', route: '/groupmsttable' },
    { label: 'SubGroups', route: '/subgrpmsttable' },
    { label: 'Ledgers', route: '/ledgertable' },
    { label: 'Other Charges', route: '/otherchargestable' },
    { label: 'Billing Scheme', route: '#' },

    // Fifth Grid
    { label: 'Ticket Category', route: '/ticket-category-table' },
    { label: 'Warden/Vendor Allocation', route: '/warden-allocation-table' },
    { label: 'Ticket SubCategory', route: '/ticket-subcategory-table' },
    { label: 'Service/Complaint Master', route: '/service-table' },
    { label: 'Ticket Status', route: '/ticket-status' },

    // Sixth Grid (duplicate of third grid - removed duplicates)

    // Seventh Grid
    { label: 'House Keeping Type Master', route: '/hk-typetable' },
    { label: 'House Keeping', route: '#' },
    { label: 'Machine Master', route: '#' },
    { label: 'Maintenance Type', route: '#' },
    { label: 'Maintenance Master', route: '#' },
    { label: 'Vehicle Master', route: '#' },
    { label: 'Shift Master', route: '/masters/shift-table' },

    // Eighth Grid
    { label: 'Module Rights', route: '/module-rights-table' },
    { label: 'User Rights', route: '/userpermission' },
    { label: 'Audit Trail', route: '/audit-report' },
    { label: 'Email Configuration', route: '/emailconfig-table' },
    { label: 'Payment Gateway Configuration', route: '/paymentGatewayConfigTable' },
    { label: 'Send Email', route: '/send-email' },
    { label: 'Bill Generation', route: '#' },

    { label: 'Enquiry', route: '/enquirytable' },
    { label: 'Follow-Ups', route: '/TableFollowUp' },
    { label: 'Booking', route: '/bookingtable' },
    { label: 'Booking Confirmation', route: '/BookingConfirmTable' },
    { label: 'Check-In', route: '/enquiry/checkintable' },
    { label: 'Check-Out', route: '/enquiry/CheckoutTable' },
    { label: 'Payment Advice', route: '/advicegeneratetable' },
    { label: 'Receipt Voucher', route: '/receipt-table' },
    { label: 'Refund', route: '/enquiry/refund' },
    { label: 'Plan Calculation', route: '/calculation' },
    { label: 'Transaction TopUp', route: '/trntopuptable' },

    // From second Grid section
    { label: 'Ticket Generation', route: '#' },
    { label: 'Ticket Dashboard', route: '/raise-tkt-dashboard' },
    { label: 'Raise Service Ticket', route: '/raise-service-tkt' },
    { label: 'Task Assignment', route: '/task-assignment' },
    { label: 'Task Acceptance', route: '/task-acceptance' },

    { label: 'MPR Calendor', route: '/operations/menpower-calendar' },
    { label: 'Attendance', route: '#' },
    { label: 'Man Power Deploymen', route: '#' },
    { label: 'Quality Checking & Control(QCS)', route: '#' },

    // Add the new options from your Grid components
    { label: 'Inward GRN', route: '/inventory/GRNTable' },
    { label: 'Asset Allocation', route: '/assetallocationtable' },
    { label: 'Asset Transfer', route: '/assettransfertable' },
    { label: 'Store Issue', route: '#' },
    { label: 'Bed Reports', route: '/bedreporttable' },
    { label: 'Booking details', route: '/reports/bookingdetails' },
    { label: 'Booking Summary', route: '/Booking' },
    { label: 'General Ledger', route: '#' },
    { label: 'Cash Book', route: '#' },
    { label: 'Bank Book', route: '#' },
    { label: 'Purchase Register', route: '#' },
    { label: 'Trial Balance', route: '#' },
    { label: 'Balance Sheet', route: '#' },
    { label: 'User & Permission', route: '/userpermission' },
    { label: 'New Calender', route: '/newcalender' },

    // Report Module.
    { label: 'Payment Request Log', route: '/paymentreqlog' },
    { label: 'Daily Summary Report', route: '/dailysummaryreport' },
    { label: 'Month Wise Bed Availability', route: '/bedcategorysummary' },
    { label: 'Bed Report Calendar', route: '/bedreporttable' },
    { label: 'Resident Account', route: '/reports/resident-account' },
    { label: 'Booking details', route: '/reports/bookingdetails' },
    { label: 'Booking Report', route: '/booking-report' },
    { label: 'Outstanding Report', route: '/outstanding' },
    { label: 'Resident Wise Details', route: '/residentwisedtl' },

  ].sort((a, b) => a.label.localeCompare(b.label));

  // Initialize speech recognition
  React.useEffect(() => {
    if (SpeechRecognition) {
      const recognitionInstance = new SpeechRecognition();
      recognitionInstance.continuous = false;
      recognitionInstance.interimResults = false;
      recognitionInstance.lang = 'en-US';
      
      recognitionInstance.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        setTranscript(transcript);
        handleVoiceResult(transcript);
      };
      
      recognitionInstance.onerror = (event) => {
        console.error('Speech recognition error', event.error);
        setIsListening(false);
      };
      
      recognitionInstance.onend = () => {
        setIsListening(false);
      };
      
      setRecognition(recognitionInstance);
    }
  }, []);

  const getFilteredModuleOptions = () => {
    return moduleOptions.filter(option => {
      const modulePermission = permissions.find(p => p.ModuleName === option.label);
      return modulePermission && (
        modulePermission.AddRec === "1" ||
        modulePermission.EditRec === "1" ||
        modulePermission.DeleteRec === "1" ||
        modulePermission.ViewRec === "1"
      );
    });
  };

  const handleOptionSelect = (event, newValue) => {
    if (newValue && newValue.route) {
      const modulePermission = permissions.find(p => p.ModuleName === newValue.label);
      if (modulePermission && (
        modulePermission.AddRec === "1" ||
        modulePermission.EditRec === "1" ||
        modulePermission.DeleteRec === "1" ||
        modulePermission.ViewRec === "1"
      )) {
        navigate(newValue.route);
      } else {
        alert("You don't have permission to access this module");
      }
    }
    setSearchValue(newValue);
  };

  // Voice search functions
  const handleVoiceClick = (event) => {
    setAnchorEl(event.currentTarget);
    if (!isListening && recognition) {
      startListening();
    }
  };

  const handleVoiceClose = () => {
    setAnchorEl(null);
    if (isListening && recognition) {
      recognition.stop();
    }
    setIsListening(false);
  };

  const startListening = () => {
    if (recognition) {
      setTranscript('');
      setIsListening(true);
      
      // Speak welcome message
      speakMessage("Which module would you like to search for? Please say the module name.");
      
      // Start recognition after a short delay
      setTimeout(() => {
        recognition.start();
      }, 1000);
    }
  };

  const speakMessage = (message) => {
    if ('speechSynthesis' in window) {
      const speech = new SpeechSynthesisUtterance(message);
      speech.lang = 'en-US';
      speech.rate = 1;
      speech.pitch = 1;
      speech.volume = 1;
      window.speechSynthesis.speak(speech);
    }
  };

  const handleVoiceResult = (voiceInput) => {
    const normalizedInput = voiceInput.toLowerCase().trim();
    
    // Find the best matching module
    const filteredOptions = getFilteredModuleOptions();
    let bestMatch = null;
    let bestMatchScore = 0;
    
    filteredOptions.forEach(option => {
      const moduleName = option.label.toLowerCase();
      
      // Simple matching logic
      if (moduleName === normalizedInput) {
        bestMatch = option;
        bestMatchScore = 100;
      } else if (moduleName.includes(normalizedInput) || normalizedInput.includes(moduleName)) {
        const score = Math.min(moduleName.length, normalizedInput.length) / Math.max(moduleName.length, normalizedInput.length) * 100;
        if (score > bestMatchScore) {
          bestMatchScore = score;
          bestMatch = option;
        }
      }
    });
    
    if (bestMatch && bestMatchScore > 50) {
      speakMessage(`Opening ${bestMatch.label}`);
      setTimeout(() => {
        handleModuleNavigation(bestMatch);
        handleVoiceClose();
      }, 1000);
    } else {
      speakMessage(`I couldn't find "${voiceInput}". Please try typing the module name.`);
      // Update search input with voice result
      if (voiceInput) {
        const inputElement = document.querySelector('.MuiAutocomplete-input');
        if (inputElement) {
          inputElement.value = voiceInput;
          inputElement.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    }
  };

  const handleModuleNavigation = (module) => {
    const modulePermission = permissions.find(p => p.ModuleName === module.label);
    if (modulePermission && (
      modulePermission.AddRec === "1" ||
      modulePermission.EditRec === "1" ||
      modulePermission.DeleteRec === "1" ||
      modulePermission.ViewRec === "1"
    )) {
      navigate(module.route);
      setSearchValue(null);
    } else {
      alert("You don't have permission to access this module");
    }
  };

  const open = Boolean(anchorEl);
  const id = open ? 'voice-search-popover' : undefined;

  // Check if browser supports speech recognition
  const browserSupportsSpeech = SpeechRecognition ? true : false;

  return (
    <Box sx={{
      display: 'flex',
      alignItems: 'center',
      gap: 1,
      mr: 2,
      width: 200,
      borderRadius: '4px',
      boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
    }}>
      <Autocomplete
        sx={{
          flexGrow: 1,
          '& .MuiOutlinedInput-root': {
            height: 35,
            backgroundColor: 'white',
            paddingLeft: '12px',
          },
          '& .MuiAutocomplete-input': {
            padding: '8.5px 4px !important',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: '#ccc',
          },
          '&:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: '#999',
          },
        }}
        options={getFilteredModuleOptions()}
        getOptionLabel={(option) => option.label}
        value={searchValue}
        onChange={handleOptionSelect}
        renderInput={(params) => (
          <TextField
            {...params}
            variant="outlined"
            size="small"
            InputProps={{
              ...params.InputProps,
              startAdornment: (
                <>
                  <InputAdornment position="start">
                    <SearchIcon sx={{ color: '#635bff' }} />
                  </InputAdornment>
                  {params.InputProps.startAdornment}
                </>
              ),
              endAdornment: (
                <>
                  <IconButton
                    size="small"
                    onClick={handleVoiceClick}
                    disabled={!browserSupportsSpeech}
                    sx={{
                      padding: '4px',
                      color: isListening ? '#ff4444' : '#635bff',
                      '&:hover': {
                        backgroundColor: 'rgba(99, 91, 255, 0.1)',
                      }
                    }}
                  >
                    {isListening ? <MicOffIcon fontSize="small" /> : <MicIcon fontSize="small" />}
                  </IconButton>
                  {params.InputProps.endAdornment}
                </>
              ),
            }}
            inputProps={{
              ...params.inputProps,
              placeholder: "Search module"
            }}
            sx={{
              '& .MuiInputLabel-root': {
                color: '#635bff',
              },
              '& .Mui-focused .MuiInputLabel-root': {
                color: '#635bff',
              },
              '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
                transform: 'translate(14px, -6px) scale(0.75)',
              },
            }}
          />
        )}
      />

      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleVoiceClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        PaperProps={{
          sx: {
            p: 2,
            mt: 1,
            minWidth: 300,
            borderRadius: 2,
            boxShadow: '0 4px 20px rgba(0,0,0,0.15)',
          }
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <IconButton
            onClick={isListening ? () => recognition.stop() : startListening}
            sx={{
              backgroundColor: isListening ? '#ff4444' : '#635bff',
              color: 'white',
              '&:hover': {
                backgroundColor: isListening ? '#cc0000' : '#4a42d4',
              }
            }}
          >
            {isListening ? <MicOffIcon /> : <MicIcon />}
          </IconButton>
          
          <Box sx={{ flexGrow: 1 }}>
            <Typography variant="subtitle1" fontWeight="bold">
              Voice Search
            </Typography>
            <Typography variant="body2" color="text.secondary">
              {isListening ? 'Listening... Say a module name' : 'Click mic to start'}
            </Typography>
            
            {transcript && (
              <Typography variant="body2" sx={{ mt: 1, fontStyle: 'italic' }}>
                You said: "{transcript}"
              </Typography>
            )}
            
            {isListening && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mt: 1 }}>
                <CircularProgress size={16} />
                <Typography variant="caption">Processing...</Typography>
              </Box>
            )}
          </Box>
        </Box>
        
        {!browserSupportsSpeech && (
          <Typography variant="caption" color="error" sx={{ mt: 1, display: 'block' }}>
            Your browser doesn't support voice recognition. Try Chrome or Edge.
          </Typography>
        )}
        
        <Box sx={{ mt: 2 }}>
          <Typography variant="caption" color="text.secondary">
            Try saying:
          </Typography>
          <Box component="ul" sx={{ pl: 2, mt: 0.5, mb: 0 }}>
            <li><Typography variant="caption">"Room Master"</Typography></li>
         
          </Box>
        </Box>
      </Popover>
    </Box>
  );
};

export default SearchModule;